import { get } from 'lodash';

export class MapAttribution {
  private readonly L: any;

  constructor(l: any) {
    /* current agreement (2018-Feb-28) with mapbox is we do not need to show watermark
        if( L && L.Control && L.Control.extend && L.control && !L.Control.Watermark) {
            L.Control.Watermark = L.Control.extend({
              onAdd: (map) => {
                let wink = L.DomUtil.create('a');
                wink.href = 'http://mapbox.com/about/maps';
                wink.className = "mapbox-wordmark";
                wink.setAttribute('target', '_blank');
                return wink;
              },
              onRemove: (map) => {}
            });

            L.control.watermark = function(opts) {
                return new L.Control.Watermark(opts);
            };
        }
        */
    this.L = l;
  }

  addTo(map) {
    if (map && this.L && this.L.control && get(this.L.control, 'attribution')) {
      /* current agreement (2018-Feb-28) with mapbox is we do not need to show watermark
            if(L.control.watermark) {
                L.control.watermark({ position: 'bottomleft' }).addTo(map);
            }
            */

      const credits = this.L.control.attribution({ prefix: false }).addTo(map);
      credits.addAttribution(
        // tslint:disable-next-line:max-line-length
        '© <a href="https://www.mapbox.com/about/maps/" target="_blank">Mapbox</a> | © <a href="http://www.openstreetmap.org/about" target="_blank">OpenStreetMap</a> | <a href="https://www.mapbox.com/map-feedback/" target="_blank">Improve this map</a>'
      );
    }
  }
}
